// extracted by mini-css-extract-plugin
export default {"tooltip":"UQ-z","arrow":"VQ-z"};